<template>
  <ClientOnly>
    <button
      v-if="wishlistRemove"
      type="button"
      :title="t('delete')"
      :aria-label="t('delete')"
      class="bg-neutral-900/30 rounded-lg py-2 px-2"
      @click="removeFromWishList"
    >
      <UiIcon src="/svg/icons/trashcan.svg" width="22" height="22" class="fill-white inline-block" aria-hidden="true" />
    </button>
    <button
      v-if="wishlistProductPage"
      type="button"
      class="tooltip"
      :aria-label="status ? t('deactive_wishlist') : t('active_wishlist')"
      @click="changeStatus"
    >
      <UiProductButton>
        <template #icon>
          <UiIcon
            v-show="status"
            src="/svg/icons/heart-fill.svg"
            width="22"
            height="22"
            class="fill-cta-500"
            :class="{'heart_animate': animation}"
          />
          <UiIcon
            v-show="!status"
            src="/svg/icons/heart-stroke.svg"
            width="22"
            height="22"
            class="fill-white"
            :class="{'heart_animate': animation}"
          />
        </template>
        <template #text>
          <span class="hidden lg:block ml-1">
            {{ t('save') }}
          </span>
        </template>
      </UiProductButton>
    </button>
    <button
      v-if="!wishlistProductPage && !wishlistRemove"
      :aria-label="status ? t('deactive_wishlist') : t('active_wishlist')"
      :class="['rounded-lg py-2 px-2 tooltipcard']"
      @click="changeStatus"
    >
      <UiIcon
        v-show="status"
        src="/svg/icons/heart-stroke-and-fill-full.svg"
        width="22"
        height="22"
        class="fill-cta-500 inline-block"
        :class="{'heart_animate': animation}"
      />
      <UiIcon
        v-show="!status"
        src="/svg/icons/heart-stroke-and-fill.svg"
        width="22"
        height="22"
        class="fill-neutral-900/50 inline-block"
        :class="{'heart_animate': animation}"
      />
      <WishlistTooltip :status="status" />
    </button>
  </ClientOnly>
</template>

<script setup lang="ts">
import type { Ref } from 'vue'
import { useWishListStore } from '~~/stores/wishList'

const t = useTranslations('WishlistHeartIcon').translate
const { log } = useGuestActivityLog()
const { isLoggedIn } = useGuest()

const props = defineProps({
  objectId: {
    type: [Number, String],
    default: null
  },
  wishlistStyle: {
    type: String,
    default: ''
  }
})

const wishlistRemove = computed(() => props.wishlistStyle === 'remove')
const wishlistProductPage = computed(() => props.wishlistStyle === 'product_page')

const animation: Ref<boolean> = ref(false)

const status = computed<boolean>({
  get () {
    if (import.meta.client) {
      const wishListStore = useWishListStore()
      return wishListStore.statusOfObjectInWishList(Number(props.objectId))
    }
    return false
  }
  // set (val) { wishListStore.itemsCount = val }
})

function changeStatus () {
  const wishListStore = useWishListStore()
  const added = wishListStore.AddOrRemoveObjectInWishListAndGetStatus(Number(props.objectId))
  animation.value = true
  log(added ? 'wishlist_add' : 'wishlist_remove', {
    object_id: Number(props.objectId),
    source: isLoggedIn.value ? 'authenticated' : 'anonymous'
  })
}
function removeFromWishList () {
  const wishListStore = useWishListStore()
  wishListStore.removeObjectFromWishList(Number(props.objectId))
  log('wishlist_remove', {
    object_id: Number(props.objectId),
    source: isLoggedIn.value ? 'authenticated' : 'anonymous'
  })
}
</script>

<style scoped>
.icon-favherz-delete-only {
  border-radius: 10rem;
  width: 32px;
  height: 32px;
  background: rgba(255,255,255,.8) none;
  padding: 4px 8px;
}
.heart_animate{
  animation: heartbeat 1s 1;
}
@keyframes heartbeat
{
  0%
  {
    transform: scale( 1 );
  }
  20%
  {
    transform: scale( .75 );
  }
  40%
  {
    transform: scale( 1 );
  }
  60%
  {
    transform: scale( .75 );
  }
  80%
  {
    transform: scale( 1 );
  }
  100%
  {
    transform: scale( 1 );
  }
}
</style>
